import { Observable } from 'rxjs/Observable';
import { ActionOptionsArgs } from '../../../core/store/actions/base-actions';
import { arrayPushUnique } from '../../../core/util/array-push-unique';
import { isInArray } from '../../../core/util/is-in-array';
import { removeFromArray } from '../../../core/util/remove-from-array';
import { intersect } from '../../../core/util/utils';
import { Control } from '../control/control.model';
import { Group } from '../group/group.model';
import { Qry } from '../query-facade';
import {
    RestrictedAccountObjectStoreFacade
} from '../restricted-account-object/restricted-account-object.store-facade';
import * as actions from './form.actions';
import { Form, FormInlined } from './form.model';

export class FormStoreFacade extends RestrictedAccountObjectStoreFacade<Form> {

    getAll(): Observable<Array<Form>> {
        return this.select(Qry.getInstance().form.byActiveAccount);
    }

    getAllInlined(): Observable<Array<FormInlined>> {
        return this.select(Qry.getInstance().form.byActiveAccountInlined);
    }

    getAllAccounts(): Observable<Array<Form>> {
        return this.select(Qry.getInstance().form.items);
    }

    getAllAccountsInlined(): Observable<Array<FormInlined>> {
        return this.select(Qry.getInstance().form.inlined);
    }

    create(form: Form): void {
        this.submit(form);
    }

    update(form: Form): void {
        this.submit(form);
    }

    insert(form: Form): void {
        this.dispatch(new actions.SubmitAction(form, {persistable: true, restful: false}));
    }

    remove(form: Form, options?: ActionOptionsArgs): void {

        // remove the form's id from any groups that reference it
        this.appFacade.objects.group.store
            .getAll()
            .take(1)
            .subscribe(groups => {
                groups.forEach(group => {
                    this.appFacade.objects.group.store.detachForm(group, form);
                });
            });

        // remove the form
        this.dispatch(new actions.RemoveAction(form, options));
    }

    attachGroup(form: Form, group: Group): void {

        if (!group || !form) {
            return;
        }

        if (isInArray(form.id, form.groups)) {
            return;
        }

        this.dispatch(new actions.SubmitAction(new Form({
            ...form,
            groups: arrayPushUnique(form.groups as Array<string>, group.id)
        })));
    }

    detachGroup(form: Form, group: Group): void {

        if (!group || !form) {
            return;
        }

        if (!isInArray(group.id, form.groups)) {
            return;
        }

        this.dispatch(new actions.SubmitAction(new Form({
            ...form,
            groups: removeFromArray(form.groups, group.id)
        })));
    }

    protected submit(form: Form): void {

        let groups: Array<Group> = [];

        this.appFacade.objects.group.store.getAll().take(1).subscribe(_groups => groups = _groups);

        const groupIds = groups.map(group => group.id);
        const groupIdIntersection = intersect(form.groups, groupIds);

        // ensure the form does not contain any group ids that do not exist (yet)
        this.dispatch(new actions.SubmitAction(new Form({
            ...form,
            groups: groupIdIntersection
        })));

        // make sure the id of this Form is added to each Group it references
        form.groups.forEach(groupId => {
            const group = groups.find(g => g.id === groupId);
            this.appFacade.objects.group.store.attachForm(group, form);
        });
    }

    updateFromApi(entities: {
        control: Array<Control>,
        form: Array<Form>,
        group: Array<Group>
    }): void {
        this.dispatch(new actions.UpdateFromApi(entities));
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/form/form.store-facade.ts